export const matchesEmailFilter = (internalRequest, emailFilter, email) => {
  if (!internalRequest && email?.toLowerCase().includes('qualisflow.com')) {
    return false
  }

  return email?.toLowerCase().includes(emailFilter.toLowerCase())
}
